export default {
  'YouTube and High Definition Videos': "YouTube en hoge definitie video's",
  'Story videos (Instagram/Snaps/TikTok)': "Verhaal video's(Instagram/Snaps/TikTok)",
  'Facebook and Instagram Feed videos': "Facebook- en Instagramfeedvideo's",
  'Facebook and Twitter Portrait Videos': "Facebook- en Twitter-portretvideo's",
  'Twitter and Facebbok Landscape Videos': "Twitter en Facebok Landschapsvideo's",
  'Facebook Cover Videos And Blog Banners': "Facebook Omslagvideo's en Blog Banners",
  'Fit': 'Pasvorm',
  'Fill': 'Vullen',
}